import type { ToastTitleProps } from './types'

import { Toast as BaseToast } from '@base-ui/react/toast'

import { textVariants } from '#components/text/styles'
import { TextColor, TextSize, TextWeight } from '#components/text/types'
import { cn } from '#lib/cn'

export function ToastTitle({ className, ...props }: ToastTitleProps) {
  return (
    <BaseToast.Title
      className={cn(
        'm-0',
        textVariants({
          size: TextSize.Medium,
          weight: TextWeight.Strong,
          color: TextColor.Inherit,
        }),
        className,
      )}
      {...props}
    />
  )
}
ToastTitle.displayName = 'Toast.Title'
